module.exports = __webpack_public_path__ + "static/media/warning.47704392.svg";


//////////////////
// WEBPACK FOOTER
// ./src/iconic/warning.svg
// module id = 382
// module chunks = 0